<!--  -->
<template>
  <div class="newslist">
    <ul class="news-list">
      <li class="first-list" v-if="newsList[0]">
        <div class="first-photo">
          <img :src="newsList[0].src" />
        </div>
        <div class="first-main">
          <h2>{{ newsList[0].time }}</h2>
          <div class="fenge"></div>
          <router-link :to="newsList[0].url" target="_blank">
            <h1>
              {{ newsList[0].title }}
            </h1>
          </router-link>
          <p>
            {{ newsList[0].msg }}
          </p>
          <div class="details">
            <router-link :to="newsList[0].url" target="_blank">
              <span>{{ details }}</span>
            </router-link>
          </div>
        </div>
      </li>
      <li
        class="last-list"
        v-for="(item, index) in newsList.slice(1)"
        :key="index"
      >
        <div class="last-photo">
          <img class="imgControl" :src="item.src" />
        </div>
        <div class="last-main">
          <div class="last-time">
            <h1>{{ item.year }}</h1>
            <h2>{{ item.month }}</h2>
          </div>
          <div class="fenge"></div>
          <div class="last-text">
            <router-link :to="item.url" target="_blank">
              <h1>{{ item.title }}</h1>
            </router-link>
            <p>
              {{ item.msg }}
            </p>
          </div>
          <div class="look-more">
            <router-link :to="item.url" target="_blank">
              <div class="look">
                <span>{{ lookmore }}</span>
              </div>
              <div class="more">></div>
            </router-link>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      details: "", //查看详情
      lookmore: "", //查看更多
    };
  },
  props: {
    newsList: {
      type: Array, // 定义接收到的数据的类型
      required: false, //规定这个数据是否必传,默认false
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.details = obj.data["ckxq"];
            that.lookmore = obj.data["ckgd"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.newslist {
  width: $main-width;
  margin: 60px auto 120px;
  .news-list {
    width: 100%;
    .first-list {
      width: 100%;
      display: flex;
      justify-content: space-between;
      position: relative;
      .first-photo {
        width: 680px;
        height: 430px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .first-main {
        width: 500px;
        height: 100%;
        h2 {
          font-size: 1.2rem;
          color: #333;
          font-weight: 500;
        }
        .fenge {
          width: 105px;
          height: 1px;
          background: #666666;
          margin: 30px 0;
        }
        h1 {
          font-size: 1.3rem;
          color: #333;
          font-weight: 500;
          line-height: 1.5;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        p {
          margin-top: 30px;
          font-size: 1.1rem;
          color: #666;
          line-height: 1.5;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;
        }
        .details {
          position: absolute;
          bottom: 0;
          padding: 5px 10px;
          background: #9241bb;
          text-align: center;
          span {
            font-size: 1rem;
            color: #fff;
          }
        }
      }
    }
    .last-list {
      margin-top: 50px;
      width: 100%;
      height: 200px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      transition: 0.3s;
      .last-photo {
        width: 24%;
        height: 100%;
      }
      .last-main {
        width: 76%;
        display: flex;
        align-items: center;
        .last-time {
          width: 10%;
          margin: 0 10px;
          text-align: center;
          h1 {
            font-size: 1.3rem;
            color: #666666;
          }
          h2 {
            font-size: 0.9rem;
          }
        }
        .fenge {
          width: 1px;
          height: 75px;
          background: #cccccc;
          margin-right: 20px;
        }
        .last-text {
          margin: 0 20px;
          width: 62%;
          cursor: pointer;
          h1 {
            color: #333;
            font-size: 1.2rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            transition: 0.3s;
          }
          p {
            margin-top: 10px;
            color: #666;
            font-size: 1rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .look-more {
          margin-left: 30px;
          a {
            width: 133px;
            height: 46px;
            background: #47aeea;
            display: flex;
            .look {
              width: 75%;
              color: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              span {
                font-size: 0.8rem;
                line-height: 1;
              }
            }
            .more {
              width: 25%;
              height: 46px;
              background: #f8ad17;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
            }
          }
        }
      }
    }
    .last-list:hover {
      box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);
    }
    .last-list:hover .last-text h1 {
      color: #0069b5;
    }
  }
}
@media screen and (max-width: $main-width) {
  .newslist {
    width: 100%;
    .news-list {
      .first-list {
        padding: 0 10px;
        flex-direction: column;
        justify-content: center;
        .first-photo {
          width: 100%;
          height: auto;
        }
        .first-main {
          margin-top: 20px;
          width: 100%;
          .details {
            bottom: -40px;
          }
        }
      }
      .last-list {
        padding: 0 10px;
        height: auto;
        flex-direction: column;
        justify-content: center;
        .last-photo {
          width: 80%;
          margin: 0 auto;
        }
        .last-main {
          border-top: 1px solid #cccccc;
          border-bottom: 1px solid #cccccc;
          width: 100%;
          flex-direction: column;
          .last-time {
            width: 90%;
            margin: 10px auto;
            text-align: left;
          }
          .fenge {
            display: none;
          }
          .last-text {
            width: 90%;
            margin: 10px auto;
            text-align: left;
          }
          .look-more {
            margin: 10px 0 10px 120px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/news/NewsList.vue